import { createAction } from 'redux-actions';
import { actionTypes as system } from '../System';
import { handleActions } from '../../Utility/HandleActions';
import { createSelector } from 'reselect';
import { selectors as currencySelectors } from '../Data/Currency';

const DEFAULTS = {
    //Currency CNY replaced with CNH
    ccyPairs: ['EUR_USD', 'EUR_JPY', 'EUR_CNH', 'EUR_SEK', 'EUR_GBP', 'EUR_PLN', 'EUR_SGD', 'EUR_CHF'],
};

const isValid = (homeOptions) => {
    return homeOptions && homeOptions.ccyPairs;
};

const CHANGE_HOME_OPTIONS = 'DBM/UI/HOME/CHANGE_OPTIONS';

export const actionTypes = {
    CHANGE_HOME_OPTIONS
};

const changeHomeOptions = createAction(CHANGE_HOME_OPTIONS, homeOptions => ({ homeOptions }));
export const actions = {
    changeHomeOptions
};

export const reducer = handleActions({
    [system.INIT]: () =>
        (state) => {
            return state.setIn(['ui', 'home', 'options'], DEFAULTS);
        }
    ,

    [CHANGE_HOME_OPTIONS]: (payload) =>
        (state) => {
            if (isValid(payload.homeOptions)) {
                return state.setIn(['ui', 'home', 'options'], payload.homeOptions);
            } else {
                return state.setIn(['ui', 'home', 'options'], DEFAULTS);
            }
        }
});

const getHomeOptionsRaw = (state) => state.getIn(['ui', 'home', 'options']);

const getHomeOptions = (state) => state.getIn(['ui', 'home', 'options']);


export const selectors = {
    getHomeOptions
};
